import React, { PureComponent } from 'react';
import { DLTextField } from 'appSrc/components/UI';

export default class FormTextField extends PureComponent {
    render() {
        const { input: { name, value, onChange, onFocus, onBlur }, meta: { error, touched, dirty } } = this.props;
        var props = {
            ...this.props,
            name,
            value,
            onChange,
            onFocus,
            onBlur,
            error: ( dirty || touched ) ? error : undefined,
        };

        return (
            <DLTextField { ...props } />
        );
    }
}

FormTextField.defaultProps = {
    className: '',
    style: {},
};
